var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMastercardLogo = function SvgMastercardLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.167,
    y: 0.5,
    width: 45.667,
    height: 31,
    rx: 4.833,
    fill: "#fff",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.333 22.876a9 9 0 0 1-5.901 2.199c-5.025 0-9.099-4.121-9.099-9.204 0-5.084 4.074-9.204 9.099-9.204 2.252 0 4.313.827 5.901 2.198a9.001 9.001 0 0 1 5.902-2.198c5.025 0 9.098 4.12 9.098 9.204 0 5.083-4.073 9.204-9.098 9.204a9.001 9.001 0 0 1-5.902-2.2Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.333 22.876a9.227 9.227 0 0 0 3.197-7.005 9.228 9.228 0 0 0-3.197-7.006 9.001 9.001 0 0 1 5.902-2.198c5.025 0 9.098 4.12 9.098 9.204 0 5.083-4.073 9.204-9.098 9.204a9 9 0 0 1-5.902-2.2Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.333 22.876a9.228 9.228 0 0 0 3.197-7.005 9.228 9.228 0 0 0-3.197-7.006 9.228 9.228 0 0 0-3.196 7.006 9.228 9.228 0 0 0 3.196 7.005Z",
    fill: "#FF5E00"
  })));
};
export default SvgMastercardLogo;